import { Component, ViewChild } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-leave-dual-policy',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './leave-dual-policy.component.html',
  styleUrl: './leave-dual-policy.component.scss'
})
export class LeaveDualPolicyComponent {
  isDisabled: boolean = false;
  LeaveData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private leave: LeaveService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
    private toast: ToastService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_LeaveDualApplicabilitySelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_LeaveDualApplicabilitySelect() {
    this.isDisabled = true;
    this.leave.ESS_LeaveDualApplicabilitySelect({SelectType: 'M'}).subscribe({
      next: (response) => {
        if (response && response.Table) {
          this.TableDatas = Object.values(response.Table);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'LeaveDualPolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.LeaveData = data;
        if (this.LeaveData.length > 0) {
          this.download.exportToExcel(this.LeaveData, "LeaveDualRulePolicies_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }

      });
  }
}
